import React from 'react';
// import SarasDnDList from '../../../../library/hooks/bdnd/SarasDnDList';
import SarasDnDList from '../../../../library/hooks/dndkit/SarasDnDList';
import CalPlanItem from './CalPlanItem';
import CalWeekSummary from './CalWeekSummary';

const isTodayWithinWeek = (weekStartDate, weekEndDate) => {
    if (!weekStartDate || !weekEndDate) return false;

    const start = new Date(weekStartDate);
    const end = new Date(weekEndDate);
    const today = new Date();

    if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime())) return false;

    start.setHours(0, 0, 0, 0);
    end.setHours(23, 59, 59, 999);
    today.setHours(12, 0, 0, 0);

    return today >= start && today <= end;
};

const CalWeekLane = ({ rowKey, viewData, sarasDnDManager, calendarControl, laneWidth, laneIndex, isTabletWidthOrLess, onMoveDate, weekSummary }) => {
    const weekLabel = viewData?.dataList?.weekLabel || '';
    const weekEndDate = viewData?.dataList?.weekEndDate || '';
    const weekStartDate = viewData?.dataList?.weekStartDate || '';
    const itemKeys = sarasDnDManager.getGroupRowsKeys(viewData);
    const isDragEnabled = sarasDnDManager.isSortMode() && !calendarControl?.isCalendarReadOnly;
    const displayMode = calendarControl?.getSetting
        ? calendarControl.getSetting('displayMode', 'mini')
        : 'mini';
    const isCurrentWeek = isTodayWithinWeek(weekStartDate, weekEndDate);
    const listWrapperStyle = displayMode === 'photo'
        ? { display: 'flex', flexWrap: 'wrap', alignContent: 'flex-start' }
        : undefined;

    console.log('calendar lane drag state', {
        rowKey,
        weekLabel,
        weekEndDate,
        isDragEnabled,
        isSortMode: sarasDnDManager.isSortMode(),
        isCalendarReadOnly: calendarControl?.isCalendarReadOnly,
        displayMode,
        itemCount: itemKeys.length
    });

    return (
        <div
            className={`uiCalWeekLane ${isCurrentWeek ? 'uiCalWeekLaneCurrent' : ''}`}
            style={{
                position: 'absolute',
                top: '0',
                left: `${laneIndex * laneWidth}px`,
                width: `${laneWidth}px`,
                height: '560px',
                borderRight: '1px solid rgba(49, 67, 93, 0.08)',
                borderBottom: '1px solid rgba(49, 67, 93, 0.08)',
                borderLeft: laneIndex === 0 ? '1px solid rgba(49, 67, 93, 0.08)' : '0',
                background: '#fff',
                display: 'flex',
                flexDirection: 'column',
                overflow: 'hidden',
                boxSizing: 'border-box'
            }}
        >
            <div className={`uiHeaderBlock ${isCurrentWeek ? 'uiCalWeekLaneHeaderCurrent' : ''}`} style={{ padding: '12px 14px 10px', borderBottom: '1px solid rgba(49, 67, 93, 0.06)', background: '#f9fbfe' }}>
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        gap: '8px'
                    }}
                >
                    <div style={{ fontWeight: 700, color: '#33455f', whiteSpace: 'nowrap' }}>{weekLabel}</div>
                    <div style={{ fontSize: '12px', color: '#6a788e', textAlign: 'right', whiteSpace: 'nowrap' }}>{weekEndDate}</div>
                </div>
            </div>

            <div className="uiContentBlock" style={{ padding: '0', minHeight: '0', flex: '1 1 auto', overflowY: 'auto', overflowX: 'hidden' }}>
                <SarasDnDList groupKey={rowKey} sarasDnDManager={sarasDnDManager} wrapperStyle={listWrapperStyle}>
                    {itemKeys.length > 0 ? itemKeys.map((itemKey, index) => (
                        <CalPlanItem
                            key={itemKey}
                            rowKey={itemKey}
                            index={index}
                            viewData={sarasDnDManager.getGroupRow(viewData, itemKey)}
                            calendarControl={calendarControl}
                            isTabletWidthOrLess={isTabletWidthOrLess}
                            onMoveDate={onMoveDate}
                            isSortMode={isDragEnabled}
                        />
                    )) : (
                        <li
                            style={{
                                listStyle: 'none',
                                minHeight: '150px',
                                color: '#8a97aa',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                textAlign: 'center',
                                padding: '12px'
                            }}
                        >
                            No jobs planned
                        </li>
                    )}
                </SarasDnDList>
            </div>

            <CalWeekSummary weekSummary={weekSummary} hasItems={itemKeys.length > 0} />
        </div>
    );
};

export default CalWeekLane;
